// extracted by mini-css-extract-plugin
export default {"root":"_24ddJm1Q5s","h1":"B4QNkMu-0t"};